import { memo, useCallback } from 'react';
import { Annotation, Project } from '../../../../types/graphqlTypes';
import FilterIcon from '../../../../assets/icons/filter.svg?react';
import { useReactiveProperty } from '../../../Properties/reactive/useReactiveProperty';
import { PropertyType } from '../../../Properties/types';
import { ensureFilterTogglePropertyRegistered } from '../../../Properties/integration/annotations/FilterToggleProperty';

const AnnotationsFilterIcon_: React.FC2<{
  project?: Pick<Project, 'id'>;
  annotation?: Pick<Annotation, 'identifier'> & { type?: Annotation['type'] };
}> = ({ project, annotation }) => {
  const identifier = annotation?.identifier || '';
  ensureFilterTogglePropertyRegistered(identifier);

  const [isFilterEnabled, setFilterEnabled] = useReactiveProperty({
    projectId: project?.id || '',
    identifier: `filter.${identifier}`,
    objectIdentifier: 'toggles',
    propertyType: PropertyType.PROJECT_USER,
  });

  const onToggleFilter = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      setFilterEnabled(!isFilterEnabled);
    },
    [isFilterEnabled, setFilterEnabled],
  );

  return (
    <div onClick={onToggleFilter} className={`flex items-center justify-center w-6 h-6 cursor-pointer ${isFilterEnabled ? 'text-black dark:text-neon-green-300' : 'text-[#6F7173] hover:text-black dark:hover:text-neon-green-300'}`}>
      <FilterIcon className="w-4 h-4" />
    </div>
  );
};

export const AnnotationsFilterIcon = memo(AnnotationsFilterIcon_);
